import { Injectable } from '@angular/core';
import { CentralService } from '../central.service';

@Injectable({
  providedIn: 'root'
})

export class AboutUsService extends CentralService {

  protected resource: string = "about-us";

}
